<style scoped>  

  @media only screen and (min-width: 991px) {
    .content {
      height: 150px;
    }
    .details {    
      height: 380px;
      transition: 0.3s linear;
    }
  }

</style>

<template>

  <div :id="_uid" class="ui small modal" :class="modalSelector">
    <div class="ui header">
      {{ isCreating ? "Adicionar Parcela" : "Alterar Parcela " + receivable.sequence }}
    </div>
    <div class="content" :class="{ details }">
      <div class="ui form" :class="{ loading }">                
        <div class="fields">
          <div class="five wide field">
            <label class="form-label">Valor <span class="red text">*</span></label>
            <input class="money" :value="receivableValue" @blur="receivableValue = $event.target.value">
          </div>
          <div class="eleven wide field">
            <label class="form-label">Forma de Pagamento <span class="red text">*</span></label>
            <select-dropdown ref="paymentTypeDropdown" @onChange="onChangePaymentType" />
          </div>            
        </div>        
        <div v-if="!details" class="fields m-t-20">
          <div class="sixteen wide field">
            <a class="clickable" @click="onShowDetails()">
              <i class="plus icon"></i> Mais informações 
            </a>
          </div>
        </div>        
        <div v-show="showDetails" class="fields">
          <div class="five wide field">
            <label class="form-label">Desconto Simavet</label>
            <input class="money" :value="companyDiscount" @blur="companyDiscount = $event.target.value">
          </div>
          <div class="five wide field">
            <label class="form-label">Desconto Colaborador</label>
            <input class="money" :value="employeeDiscount" @blur="employeeDiscount = $event.target.value">
          </div>
          <div class="five wide field">
            <label class="form-label">Valor Recebido</label>
            <input class="money" :value="receivedValue" readonly="readonly">
          </div>          
        </div>
        <div v-show="showDetails" class="fields">
          <div class="five wide field">
            <label class="form-label">Data Receb. <span v-if="!disableReceivementFields" class="red text">*</span></label>
            <date-picker ref="receiptDatePicker" :autoInit="false" :readonly="disableReceivementFields" @onChange="onChangeReceiptDate" />
          </div>
          <div class="five wide field">
            <label class="form-label">Ref. Receb. <span v-if="!disableReceivementFields" class="red text">*</span></label>
            <date-picker ref="receiptRefDatePicker" :autoInit="false" :readonly="disableReceivementFields" @onChange="onChangeReceiptRefDate" />
          </div>
        </div>
        <div v-show="showDetails" class="fields">
          <div v-show="!disableReceivementFields" class="sixteen wide field">
            <label class="form-label">Recebido por <span class="red text">*</span></label>
            <select-dropdown ref="userDropdown" @onChange="onChangeUser" />
          </div>
          <div v-show="disableReceivementFields" class="sixteen wide field">
            <label class="form-label">Recebido por</label>
            <input type="text" readonly="readonly">
          </div>
        </div>
        <div v-show="showDetails" class="inline fields m-t-20">
          <div class="field">
            <div class="ui checkbox issues-invoice-checkbox" :class="{ disabled: isBankSlip || isWaitingTransfer }">
              <input type="checkbox" tabindex="0" class="hidden" v-model="notReceived">
              <label>Parcela não recebida</label>
            </div>
          </div>
          <div class="field">
            <div class="ui checkbox issues-invoice-checkbox m-l-20" :class="{ disabled: isBankSlip }">
              <input type="checkbox" tabindex="0" class="hidden" v-model="receivable.issuesInvoice">
              <label>Nota Fiscal</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>            
      <button class="ui blue button" :class="{ disabled: !canConfirm }" @click="onConfirm()">
        <i class="checkmark icon"></i>
        {{ isCreating ? "Confirmar" : "Atualizar" }}
      </button>
    </div>
  </div>  

</template>

<script>

  import _ from "underscore"
  import modalDialog from "@/mixins/modal-dialog"
  import Input from "@/utils/input"
  import UserService from "@/services/user-service"
  import FinancialService from "@/services/financial-service"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {

    name: "CertReceivableFormModal",

    mixins: [modalDialog],
    
    data() {
      return {
        users: [],
        details: false,
        showDetails: false,
        notReceived: false,
        userService: new UserService(),
        receivable: {},
      }
    },

    props: ["cert", "certValue", "moneyValue", "receivables"],

    components: {
      DatePicker,
      SelectDropdown,
    },

    mounted() {      
      
      Input.maskCurrency()

      $(".issues-invoice-checkbox").checkbox()

      this.loadUsers()
    },

    computed: {

      balance() {

        let totalValue = 0

        for (const receivable of this.receivables) {
          if (!receivable.removed)
            totalValue += receivable.value
        }

        return (this.certValue - totalValue)
      },      

      isBankSlip() {
        return (this.receivable.paymentType == "bank_slip")
      },

      isMoney() {
        return (this.receivable.paymentType == "money")
      },

      isWaitingTransfer() {
        return (this.receivable.paymentType == "waiting_transfer")
      },
      
      disableReceivementFields() {
        return (this.isBankSlip || this.notReceived)
      },

      receivableValue: {
        get() {
          return Input.currencyToString(this.receivable.value)
        },
        set(value) {
          this.receivable.value = Input.stringToCurrency(value)
          this.onUpdateValues()
        },
      },

      companyDiscount: {
        get() {
          return Input.currencyToString(this.receivable.companyDiscount)
        },
        set(value) {
          this.receivable.companyDiscount = Input.stringToCurrency(value)              
          this.onUpdateValues()
        },
      },

      employeeDiscount: {
        get() {
          return Input.currencyToString(this.receivable.employeeDiscount)
        },
        set(value) {
          this.receivable.employeeDiscount = Input.stringToCurrency(value)    
          this.onUpdateValues()
        },
      },

      receivedValue: {
        get() {
          return Input.currencyToString(this.receivable.receivedValue)
        },
      },

      canConfirm() {
        
        if (!this.receivable.value || !this.receivable.paymentType)
          return false

        if (!this.notReceived && (!this.receivable.receiptDate || !this.receivable.receiptRefDate))
          return false

        if (this.requireReceivedValue && (!this.receivable.receivedValue || !this.receivable.userId))  
          return false

        return true
      },
    },

    watch: {
      
      "notReceived" () {

        if (this.loading)
          return

        if (this.notReceived) {
          this.clearReceivementData()
        } else {          
          this.onChangePaymentType(this.receivable.paymentType, { fromNotReceived: true })
        }  
      },
    },

    methods: {

      async loadUsers() {

        this.loading = true

        try {

          const users = []
          const simavetUsers = await this.userService.findSimavetUsers()

          for (const user of simavetUsers) {
            users.push({ 
              id: user.id, 
              label: user.name.trim() + " " + user.lastName.trim(),
              group: user.group,
            })
          }

          this.users = _.sortBy(users, "label")
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },

      load(receivable) {
        
        this.loading = true
        this.details = false
        this.showDetails = false
        
        this.receivable = {
          value: 0,
          companyDiscount: 0,
          employeeDiscount: 0,
          receivedValue: 0,
        }

        if (receivable) {
          this.receivable = this.$cloneObject(receivable)
        } else {
          this.receivable.value = this.balance
        }  

        this.$refs.paymentTypeDropdown.setValues(FinancialService.getPaymentTypeList({ 
          hide: ["manual_input"],
        }), this.receivable.paymentType)

        this.$refs.userDropdown.setValues(this.users, this.receivable.userId)        

        this.notReceived = (this.receivable.receivedValue == 0)

        this.show()        
      },      

      onVisible() {
        this.initDatePickers()
        this.loading = false  
      },

      initDatePickers() {

        this.$refs.receiptDatePicker.initCalendar({ force: true })
        this.$refs.receiptRefDatePicker.initCalendar({ force: true })              

        if (this.receivable.receiptDate) {
          this.$refs.receiptDatePicker.setDate(this.receivable.receiptDate)
          this.$refs.receiptRefDatePicker.setDate(this.receivable.receiptRefDate)
        } else {
          this.$refs.receiptDatePicker.clearDate()
          this.$refs.receiptRefDatePicker.clearDate()
        }
      },

      onChangePaymentType(paymentType, options) {    
        
        if (this.loading)
          return

        if (!options)
          options = { fromNotReceived: false }
        
        this.receivable.paymentType = paymentType           

        if (this.isBankSlip || this.isWaitingTransfer) {

          this.notReceived = true
          this.clearReceivementData()

        } else {

          this.checkMoneyValue()

          if (!options.fromNotReceived)
            this.notReceived = false

          if (!this.notReceived)
            this.updateReceivedValue()

          if (!this.receivable.userId)
            this.$refs.userDropdown.setSelected(this.cert.userId)
        }

        this.receivable.issuesInvoice = FinancialService.shouldIssueInvoice(this.cert, this.receivable)

        this.refreshData()
      },

      checkMoneyValue() {

        if (!this.isMoney || !this.moneyValue || !this.cert.customer.moneyAuto)
          return

        const receivables = this.receivables.filter((receivable) => !receivable.removed)
        
        if ((this.isCreating && !receivables.length) || (this.isUpdating && receivables.length == 1))
          this.receivableValue = this.moneyValue            
      },

      clearReceivementData() {

        this.receivable.companyDiscount = 0
        this.receivable.employeeDiscount = 0
        this.receivable.receivedValue = 0
        this.receivable.userId = null
        this.receivable.user = null
        
        this.$refs.receiptDatePicker.clearDate()
        this.$refs.receiptRefDatePicker.clearDate()
        this.$refs.userDropdown.setValues(this.users)
        
        this.refreshData()
      },

      onUpdateValues() {
        if (!this.isBankSlip && !this.notReceived) {
          this.updateReceivedValue()
        } else {
          this.refreshData()
        }
      },

      updateReceivedValue() {
        
        this.receivable.receivedValue = (this.receivable.value - this.receivable.companyDiscount - this.receivable.employeeDiscount)

        if (!this.receivable.receiptDate)
          this.$refs.receiptDatePicker.setDate(this.cert.date)

        this.refreshData()
      },      

      onChangeReceiptDate(date) {        

        this.receivable.receiptDate = date || null

        if (!this.loading)
          this.$refs.receiptRefDatePicker.setDate(this.receivable.receiptDate)

        this.refreshData()  
      },

      onChangeReceiptRefDate(date) {
        this.receivable.receiptRefDate = date || null
        this.refreshData()
      },

      onChangeUser(id) {

        if (this.loading)
          return

        this.receivable.userId = id ? parseInt(id) : null
        this.receivable.user = this.users.find((user) => user.id == id)
        this.receivable.issuesInvoice = FinancialService.shouldIssueInvoice(this.cert, this.receivable)

        this.refreshData()
      },

      refreshData() {
        this.receivable = this.$cloneObject(this.receivable)
      },

      onShowDetails() {

        this.details = true

        setTimeout(() => this.showDetails = true, 300)
      },

      onConfirm() {

        if (!this.validData())
          return

        if (this.isBankSlip || this.isWaitingTransfer) {
          this.receivable.userId = null
          this.receivable.receivedValue = 0
        }  

        const event = this.isCreating ? "onCreate" : "onUpdate"

        this.emit(event, this.$cloneObject(this.receivable))
      },

      validData() {

        let isOk = true
        let message = ""

        if (this.receivable.receivedValue < 0) {
          message = "O valor recebido não pode ser negativo"
        } else if (this.receivable.receivedValue > 0 && !this.receivable.userId) {
          message = "Informe quem recebeu a parcela"
        }

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },
    },
  }

</script>